import { render } from "./ResponsiveTable.vue?vue&type=template&id=4aa7ef46"
import script from "./ResponsiveTable.vue?vue&type=script&lang=js"
export * from "./ResponsiveTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__